import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  Paper,
  Button,
} from "@mui/material";
import { obtenerVersionesGuion } from "../services/guiones.service";
import { validarAccesoGuiones } from '../services/accesoGuiones';
import { AuthContext } from "../context/AuthContext";
import { Barra } from "../components/Barra";

import axios from "axios";

export const obtenerUnidad = async (unidadId, token) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL_APP}unidades/unidad/${unidadId}`,
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const response = await axios(config);
  console.log(response);
  return response.data;

};

export const obtenerAsignatura = async (asignaturaId, token) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL_APP}asignaturas/asignatura/${asignaturaId}`,
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const response = await axios(config);
  console.log(response);
  return response.data;

};

export default function RevisarGuion() {
  const { unidadId } = useParams();
  const navigate = useNavigate();
  const { user } = React.useContext(AuthContext);

  const [versiones, setVersiones] = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [nombreUnidad, setNombreUnidad] = useState("");
  const [numeroUnidad, setNumeroUnidad] = useState("");
  const [nombreAsignatura, setNombreAsignatura] = useState("");
  const [codigoAsignatura, setCodigoAsignatura] = useState("");

  //const fetchVersiones = async () => {
  //  try {
  //    const data = await obtenerVersionesGuion(
  //      unidadId,
  //      user.authorization.token
  //    );
  //    if (data.versiones.length > 0) {
  //      setVersiones(data.versiones);
  //      setSeleccionada(data.versiones[0]); // Última versión
  //    }
  //  } catch (error) {
  //    console.error("Error al obtener versiones:", error);
  //  }
  //};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await obtenerVersionesGuion(
          unidadId,
          user.authorization.token
        );
        if (data.versiones.length > 0) {
          setVersiones(data.versiones);
          setSeleccionada(data.versiones[0]);
        }

        const unidad = await obtenerUnidad(unidadId, user.authorization.token);
        setNombreUnidad(unidad.name || "");
        setNumeroUnidad(unidad.codigo || "");

        const asignatura = await obtenerAsignatura(unidad.asignatura_id, user.authorization.token);
        setNombreAsignatura(asignatura.name || "");
        setCodigoAsignatura(asignatura.codigo || "");
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    const validar = async () => {
      await validarAccesoGuiones({
      rut: user.rut,
      token: user.authorization.token,
      navigate
      });
    };
    
    if (user?.rut) {
      validar();
    }

    fetchData();
  }, [unidadId, user, navigate]);


  const descargarGuion = () => {
    if (!seleccionada) return;
    const blob = new Blob([seleccionada.output], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${codigoAsignatura}_unidad_${numeroUnidad}.txt`;
    //link.download = `guion_${unidadId}_${seleccionada.id}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Barra />
      <Box p={4} mt={10}>
        <Button
          variant="outlined"
          sx={{ mb: 2, color: "#102A8A", borderColor: "#102A8A" }}
          onClick={() => navigate("/guiones")}
        >
          Volver
        </Button>

        <Typography variant="h5" sx={{ mb: 2, color: "#182844" }}>
          Asignatura: {nombreAsignatura + " | " + codigoAsignatura}
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, color: "#182844" }}>
          Revisión de Guion - Unidad  {numeroUnidad + ": " + nombreUnidad || `Unidad ${unidadId}`}
        </Typography>

        {versiones.length > 1 && (
          <Box mb={3}>
            <Typography variant="body1" mb={1}>
              Seleccionar versión:
            </Typography>
            <Select
              fullWidth
              value={seleccionada?.id || ""}
              onChange={(e) => {
                const nueva = versiones.find(
                  (v) => v.id === parseInt(e.target.value)
                );
                setSeleccionada(nueva);
              }}
            >
              {versiones.map((v) => (
                <MenuItem key={v.id} value={v.id}>
                  {v.createdat
                    ? new Date(v.createdat).toLocaleString("es-CL", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "Versión sin fecha"}
                </MenuItem>
              ))}
            </Select>
          </Box>
        )}

        {seleccionada ? (
          <>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                whiteSpace: "pre-wrap",
                fontFamily: "monospace",
                fontSize: "1rem",
                backgroundColor: "#f5f5f5",
              }}
            >
              <Typography variant="body1">{seleccionada.output}</Typography>
            </Paper>

            <Button
              variant="contained"
              sx={{ mt: 3, backgroundColor: "#102A8A" }}
              onClick={descargarGuion}
            >
              Descargar Guion
            </Button>
          </>
        ) : (
          <Typography sx={{ mt: 2 }}>
            No hay guiones generados para esta unidad.
          </Typography>
        )}
      </Box>
    </>
  );
}
